import { useTranslation } from 'react-i18next';

import lucioLogo from '@/assets/icons/LucioLogoDark.svg';

/**
 * `label` is the step the assistant is on right now (see `activitySteps`). Falls
 * back to the plain "Thinking…" copy before the turn's first tool call.
 */
export function ThinkingBanner({ label }: { label?: string | undefined }) {
  const { t } = useTranslation();
  return (
    <div className="px-6 py-2">
      <div className="bg-elevated-subtle inline-flex items-center gap-1.5 rounded-full px-3 py-1.5">
        <img
          alt="Lucio"
          className="icon-themed h-3.5 w-3.5 animate-spin"
          src={lucioLogo}
          style={{ animationDuration: '0.9s' }}
        />
        <p className="shimmer-text text-neutral-mid text-[10px] leading-[170%]">
          {label ?? t('assistant.thinking')}
        </p>
      </div>
    </div>
  );
}
